// AUTO GENERATED FILE - Changes WILL be lost.
// ko - used as 'ko' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "베팅 슬립",
  "betslip.bet": "베팅하기",
  "betslip.clear": "모두 지우기",
  "betslip.clearResult": "지우기",
  "betslip.noSelections": "베팅을 시작하려면 선택 항목 추가하세요",
  "betslip.notLoggedIn": "베팅을 시작하시려면 로그인하십시오",
  "betslip.refresh": "새로 고침",
  "betslip.totalStake": "총 베팅 금액",
  "betslip.noHistoryData": "사용 가능한 베팅 정보 없음",
  "betslip.openBets": "오픈 베팅",
  "betslip.betHistory": "베팅 히스토리",
  "betslip.betHistoryWon": "승리",
  "betslip.betHistoryLost": "패배",
  "loading.loading": "로딩",
  "loading.account": "계정 로딩 중",
  "loading.league": "리그 로딩 중",
  "loading.gameweeks": "게임 주 로딩 중",
  "loading.markets": "시장 로딩 중",
  "loading.bethistory": "베팅 기록 로드 중",
  "login.loginRequired": "로그인이 필요합니다",
  "login.loginToBet": "베팅을 시작하시려면 로그인하십시오",
  "navigation.back": "뒤로",
  "navigation.close": "닫기",
  "video.liveStreamAvailable": "라이브 스트리밍 이용 가능",
  "video.logInToWatch": "시청하기 위해 로그인하십시오.",
  "error.error": "오류",
  "error.404": "페이지를 찾을 수 없음",
  "error.gameLaunchFailed": "게임을 시작할 수 없음",
  "error.unknownErrorCode": "알 수 없는 오류: {code}",
  "error.minUnitStakeLimitExceeded": "최소 베팅 금액: {limit}",
  "error.maxUnitStakeLimitExceeded": "최대 베팅 금액: {limit}",
  "error.minTotalStakeLimitExceeded": "최소 총 베팅 금액: {limit}",
  "error.maxTotalStakeLimitExceeded": "최대 총 베팅 금액: {limit}",
  "error.notPlaced": "배치되지 않음",
  "error.wagerDisallowed": "베팅이 허용되지 않음",
  "error.errorEventIsOff": "이벤트가 시작했습니다",
  "multiplebet.Singles": "싱글",
  "multiplebet.Doubles": "더블",
  "multiplebet.Trebles": "트레블",
  "multiplebet.Accumulator": "누적",
  "multiplebet.Perm 4-Folds": "4폴드",
  "multiplebet.Perm 5-Folds": "5폴드",
  "multiplebet.Perm 6-Folds": "6폴드",
  "multiplebet.Perm 7-Folds": "7폴드",
  "multiplebet.Perm 8-Folds": "8폴드",
  "multiplebet.Perm 9-Folds": "9폴드",
  "sb-english.team.ARS": "아스널",
  "sb-english.team.AST": "애스턴 V.",
  "sb-english.team.BHA": "브라이턴",
  "sb-english.team.BOU": "본머스",
  "sb-english.team.BUR": "번리",
  "sb-english.team.CHE": "첼시",
  "sb-english.team.CRY": "C. 팰리스",
  "sb-english.team.EVE": "에버턴",
  "sb-english.team.LEI": "레스터",
  "sb-english.team.LIV": "리버풀",
  "sb-english.team.MNC": "맨체스터 C.",
  "sb-english.team.MNU": "맨체스터 U.",
  "sb-english.team.NEW": "뉴캐슬",
  "sb-english.team.SOU": "사우샘프턴",
  "sb-english.team.TOT": "토트넘",
  "sb-english.team.WAT": "왓포드",
  "sb-english.team.WHU": "웨스트햄",
  "sb-english.team.WOL": "울브스",
  "sb-english.team.NOR": "노리치",
  "sb-english.team.SHU": "셰필드 U.",
  "sb-english.team.LEE": "리즈",
  "sb-english.team.FUL": "풀럼",
  "sb-english.team.WBA": "웨스트브롬",
  "nomorebets": "베팅 불가",
  "playtime": "플레이 타임",
  "gameId": "게임 ID",
  "noGames": "사용 가능한 게임이 없습니다. 잠시 후에 다시 확인해 주세요.",
  "Home": "홈",
  "Away": "원정",
  "Visitor": "비지터",
  "soccerbet.gameWeek": "게임 주",
  "soccerbet.noGameWeeks": "이용 가능한 게임 주가 없습니다. 잠시 뒤 다시 확인하십시오.",
  "soccerbet.league": "리그 순위",
  "soccerbet.table.name": "이름",
  "soccerbet.table.won": "승",
  "soccerbet.table.drawn": "무",
  "soccerbet.table.lost": "패",
  "soccerbet.table.points": "점",
  "market.abbr.Both Teams To Score": "BTTS",
  "market.Both Teams To Score": "양 팀 득점",
  "market.Over / Under": "오버/언더",
  "market.Double Chance": "더블 찬스",
  "market.Match Result": "경기 결과",
  "market.Exact Goals": "정확한 골",
  "market.Correct Score": "정확한 점수",
  "market.Match Result Both Score": "경기 결과 양 팀 득점",
  "market.Result Und/Over 1.5 Total Goals": "결과 오버/언더 총 골 1.5",
  "market.Result Und/Over 2.5 Total Goals": "결과 오버/언더 총 골 2.5",
  "market.Under Over 1.5 Total Goals": "오버 언더 총 골 1.5",
  "market.Under Over 2.5 Total Goals": "오버 언더 총 골 2.5",
  "market.Under Over 3.5 Total Goals": "오버 언더 총 골 3.5",
  "market.Under Over 4.5 Total Goals": "오버 언더 총 골 4.5",
  "market.Total Goals 1 To 2": "총 골 1~2",
  "market.Total Goals 1 To 3": "총 골 1~3",
  "market.Total Goals 1 To 4": "총 골 1~4",
  "market.Total Goals 2 To 3": "총 골 2~3",
  "market.Total Goals 2 To 4": "총 골 2~4",
  "market.Under Over 1.5 Home Goals": "오버 언더 홈 골 1.5",
  "market.Under Over 1.5 Away Goals": "오버 언더 원정 골 1.5",
  "market.Home Team Exact Goals": "홈팀 정확한 골",
  "market.Away Team Exact Goals": "원정팀 정확한 골",
  "selection.Yes": "네",
  "selection.No": "아니오",
  "selection.1+G": "1+골",
  "selection.1+Ng": "1+노 골",
  "selection.X+G": "X+골",
  "selection.X+Ng": "X+노 골",
  "selection.2+G": "2+골",
  "selection.2+Ng": "2+노 골",
  "selection.1+Yes": "1+네",
  "selection.1+No": "1+아니오",
  "selection.X+Yes": "X+네",
  "selection.X+No": "X+아니오",
  "selection.2+Yes": "2+네",
  "selection.2+No": "2+아니오",
  "selection.TID_ANY_GOAL_SCORED_YES": "골",
  "selection.TID_ANY_GOAL_SCORED_NO": "노 골",
  "selection.U": "언더",
  "selection.O": "오버",
  "selection.1+O": "1+오버",
  "selection.X+O": "X+오버",
  "selection.2+O": "2+오버",
  "selection.1+U": "1+언더",
  "selection.X+U": "X+언더",
  "selection.2+U": "2+언더",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "sb-english.team.BRE": "브렌트포드",
  "selection.Home": "{home}",
  "selection.Visitor": "{visitor}"
}
